import { render, staticRenderFns } from "./ClosingBOMTable.vue?vue&type=template&id=80bc65c0&"
import script from "./ClosingBOMTable.vue?vue&type=script&lang=js&"
export * from "./ClosingBOMTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports